import { Link } from 'react-router-dom';
import { SessionChip } from './SessionChip';
import { StatusDot } from './StatusDot';
import { formatDateRo } from '@/lib/format';
import { useMe } from '@/lib/useMe';

/** The line that opens every page: status left, org + Romanian date right.
 *  `backTo`/`backLabel` render the `← …` detail-page back-link.
 *
 *  This is also where a minimized instance session docks (2026-08-21 UI
 *  report) — `SessionChip` renders itself only while the drawer is docked, so
 *  the line is unchanged for everyone else. */
export function DocTop({ backTo, backLabel }: { backTo?: string; backLabel?: string }) {
  const { data: me } = useMe();
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 border-b border-rule-soft pb-3 text-[13.5px]">
      <div className="flex items-center gap-4">
        {backTo && (
          <Link to={backTo} className="text-teal hover:underline">← {backLabel}</Link>
        )}
        <StatusDot />
        <SessionChip />
      </div>
      <div className="tabular-nums text-ink-3">
        {me?.orgName ? <span className="text-ink-2">{me.orgName}</span> : null}
        <span className="mx-2 text-rule">·</span>
        {formatDateRo(new Date())}
      </div>
    </div>
  );
}
